var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.183,
    height: 15.456,
    viewBox: "0 0 18.183 15.456",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11990",
    "data-name": "Group 11990",
    transform: "translate(-1666 1549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18920",
    "data-name": "Path 18920",
    d: "M130.787,36.673c1.718,0,3.112-1.692,3.112-3.779s-.458-3.78-3.112-3.78-3.112,1.692-3.112,3.78S129.068,36.673,130.787,36.673Z",
    transform: "translate(1544.305 -1578.114)",
    fill: "#adafb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18921",
    "data-name": "Path 18921",
    d: "M80.379,202.024c-.058-3.636-.532-4.672-4.167-5.328a2.553,2.553,0,0,1-3.408,0c-3.594.649-4.1,1.669-4.165,5.21-.005.289-.008.3-.009.271,0,.063,0,.179,0,.382,0,0,.865,1.744,5.877,1.744s5.877-1.744,5.877-1.744c0-.13,0-.221,0-.283A2.28,2.28,0,0,1,80.379,202.024Z",
    transform: "translate(1600.583 -1737.847)",
    fill: "#adafb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18922",
    "data-name": "Path 18922",
    d: "M262.847,51.157a2.838,2.838,0,0,0,2.527-3.07c0-1.7-.372-3.07-2.527-3.07a3.6,3.6,0,0,0-.943.112,6.2,6.2,0,0,1,.566,2.923,5.183,5.183,0,0,1-.776,2.766A2.165,2.165,0,0,0,262.847,51.157Z",
    transform: "translate(1416.563 -1593.273)",
    fill: "#adafb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18923",
    "data-name": "Path 18923",
    d: "M288.7,185.452c-.047-2.953-.432-3.795-3.384-4.327a1.769,1.769,0,0,1-1.384.529c-.04,0-.079,0-.117,0a3.883,3.883,0,0,1,1.587,1.229c.713.977.876,2.29.91,4.218,1.986-.392,2.393-1.212,2.393-1.212,0-.107,0-.18,0-.23A1.729,1.729,0,0,1,288.7,185.452Z",
    transform: "translate(1395.481 -1723.005)",
    fill: "#adafb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18924",
    "data-name": "Path 18924",
    d: "M50.482,51.158a2.166,2.166,0,0,0,1.153-.338,5.183,5.183,0,0,1-.776-2.766,6.2,6.2,0,0,1,.566-2.923,3.6,3.6,0,0,0-.943-.112c-2.156,0-2.527,1.374-2.527,3.07A2.838,2.838,0,0,0,50.482,51.158Z",
    transform: "translate(1620.291 -1593.274)",
    fill: "#adafb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18925",
    "data-name": "Path 18925",
    d: "M4.89,181.65c-.038,0-.077,0-.117,0a1.769,1.769,0,0,1-1.384-.529C.438,181.657.052,182.5.005,185.452a1.791,1.791,0,0,1-.005.2c0,.05,0,.123,0,.23,0,0,.407.819,2.393,1.212.034-1.928.2-3.241.91-4.218A3.883,3.883,0,0,1,4.89,181.65Z",
    transform: "translate(1666 -1723.004)",
    fill: "#adafb3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.5e2174506d1af73b1a956aefea6a0f49.svg";
export { ForwardRef as ReactComponent };